import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { InfoIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

let currentVersion: string | null = null;

export function VersionUpdater() {
  const { data } = useVersionUpdater();
  const [dismissed, setDismissed] = useState(false);

  if (data?.didChange && !dismissed) {
    return (
      <div
        className='fixed bottom-4 left-4 z-50 rounded-xl border bg-background p-3 px-4 shadow-md'
        style={{
          animation: 'bounce-periodic 15s infinite',
        }}
      >
        <div className='flex items-center gap-2'>
          <InfoIcon className='h-4 w-4' />
          <p className='text-sm font-medium'>New version available</p>
          <div className='ml-16 flex items-center gap-2'>
            <Button size='sm' onClick={() => setDismissed(true)} className='text-sm' variant='outline'>
              Not now
            </Button>
            <Button size='sm' onClick={() => window.location.reload()} className='text-sm'>
              Reload
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

function useVersionUpdater() {
  return useQuery({
    queryKey: ['version-updater'],
    initialData: null,
    queryFn: async () => {
      const response = await fetch('/version');
      const latestVersion = await response.text();
      if (currentVersion === null) {
        currentVersion = latestVersion;
        return { didChange: false };
      }
      return {
        didChange: currentVersion !== latestVersion,
      };
    },
  });
}
